import { render } from "./DataSourcesUploadNext.vue?vue&type=template&id=da4f1b68&ts=true"
import script from "./DataSourcesUploadNext.vue?vue&type=script&lang=ts"
export * from "./DataSourcesUploadNext.vue?vue&type=script&lang=ts"

import "./DataSourcesUploadNext.vue?vue&type=style&index=0&id=da4f1b68&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__